import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service'
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router'

declare var $: any

@Component({
  selector: 'app-incoming-contact',
  templateUrl: './incoming-contact.component.html',
  styleUrls: ['./incoming-contact.component.scss']
})
export class IncomingContactComponent implements OnInit {
  telephoneNo: any
  idCard: any

  contactList: any
  contactDa: any

  isCheckedAll = false
  selectList: any
  
  confirmMergeList : any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: ""
  }
  
  firstnameSearch: string = ""
  lastnameSearch: string = ""
  telephoneSearch: string = ""
  idcardSearch: string = ""
  accountNoSearch: string = ""

  contact1: any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: null
  }
  contact2: any = {
    firstname: "",
    lastname: "",
    birthdate: "",
    dpa_idcard: "",
    emailaddress1: "",
    telephone1: "",
    dob: null
  }

  chkMain = 1

  chkName = 1
  chkLastname = 1
  chkDob = 1
  chkIdNo = 1
  chkEmail = 1
  chkTel = 1

  dtCon: any = null

  role: any = {}
  cookieData: any
  isCrisis = true
  contactDros: any

  @ViewChildren('tbCon') tbCon: QueryList<any>;

  constructor(
    private util: UtilService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService
  ) { }

  async ngOnInit() {

    this.util.ShowWaiting(true)
    this.util.InitValidation()

    this.activatedRoute.queryParams.subscribe(params => {
      this.telephoneNo = params['phoneNo'];
      this.idCard = params['idCard'];
    });

    let para = "telephoneno=" + this.telephoneNo
    this.telephoneSearch = this.telephoneNo
    if (this.idCard != null && this.idCard.trim().length > 0) {
      para += "&idcard=" + this.idCard
      this.idcardSearch = this.idCard
    }

    this.contactList = await this.apiService.get("crmservice", "contact", para)

    this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    this.role = JSON.parse(this.cookieData.role)
    this.isCrisis = this.cookieData.isCrisis

    this.util.ShowWaiting(false)
  }

  clearActionActive() {
    $(".action-menu").each(function () {
      $(this).removeClass("active")
    })
  }

  CloseModal(modalId: string) {
    $("#" + modalId).modal("hide")
    this.clearActionActive()
  }

  newContact(event: any) {
    this.cookieData.incomingTelephoneNo = this.telephoneNo
    this.cookieData.incomingIdCard = this.idCard
    localStorage.setItem("dpa_cc", JSON.stringify(this.cookieData))

    const url = this.util.baseUrl() + `/newContact`
    window.open(url, '_blank');
  }

  async merge(event: any) {
    this.getSelectedContact()
    if (this.selectList.length != 2) {
      this.util.WarningDialog("กรุณาเลือก 2 รายการ");
    }
    else if (this.selectList[0].fullname != this.selectList[1].fullname) {
      this.util.WarningDialog("กรุณาเลือก 2 รายการที่มีชื่อ นามสกุล ตรงกัน");
    }
    else {
      this.util.ShowWaiting(true)
      let c: any
      c = await this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[0].contactId)
      this.contact1 = c[0]
      c = await this.apiService.get("crmservice", "contact", "contactid=" + this.selectList[1].contactId)
      this.contact2 = c[0]

      if (this.contact1 == null && this.contact2 == null) {
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการดึงข้อมูล Contact");
      }
      else {
        this.mainChange(1)

        this.clearActionActive()
        event.target.classList.add("active")
        $("#mergeModal").modal('show')
      }
      this.util.ShowWaiting(false)
    }
  }
  
  async beforeConfirmMerge() {
    this.util.ShowWaiting(true)

    let req: any = this.chkMain == 1 ? this.contact1 : this.contact2
    req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname
    req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname
    req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate
    req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard
    req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1
    req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1
    req.dpa_modifiedby = this.cookieData.userId
    
    this.confirmMergeList = req; 
     
    
    $("#mergeConfirmModal").modal('show')    
    $("#mergeModal").modal('hide')
    
    this.util.ShowWaiting(false)
     
  }

  async confirmMerge() {
    this.util.ShowWaiting(true)

    let req: any = this.chkMain == 1 ? this.contact1 : this.contact2
    req.firstname = this.chkName == 1 ? this.contact1.firstname : this.contact2.firstname
    req.lastname = this.chkLastname == 1 ? this.contact1.lastname : this.contact2.lastname
    req.birthdate = this.chkDob == 1 ? this.contact1.birthdate : this.contact2.birthdate
    req.dpa_idcard = this.chkIdNo == 1 ? this.contact1.dpa_idcard : this.contact2.dpa_idcard
    req.emailaddress1 = this.chkEmail == 1 ? this.contact1.emailaddress1 : this.contact2.emailaddress1
    req.telephone1 = this.chkTel == 1 ? this.contact1.telephone1 : this.contact2.telephone1
    req.dpa_modifiedby = this.cookieData.userId

    var res: any = await this.apiService.put("crmservice", "contact-merge/" + this.contact1.contactid + "/" + this.contact2.contactid, req);
    if (this.util.isSuccessResponse(res)) {
      await this.search(true)
      $("#mergeConfirmModal").modal('hide')
      this.util.SuccessDialog("Merge conatct สำเร็จ")
    }
    else {
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("Merge conatct ไม่สำเร็จ")
    }
  }

  onCheckAllChange() {
    $(".row-checker").prop("checked", this.isCheckedAll)
  }

  getSelectedContact() {
    let thisTs = this
    this.selectList = []
    $('.row-checker:checkbox:checked').each(function () {
      let value = {
        contactId: $(this).val(),
        fullname: $(this).closest('tr').find('td.col-fullname')[0].innerHTML,
        tel: $(this).closest('tr').find('td.col-tel')[0].innerHTML,
        email: $(this).prop("name")
      }
      thisTs.selectList.push(value)
    })
  }

  async search(getAll: boolean = false) {
    this.util.ShowWaiting(true)

    $('#tbContact').DataTable().clear().destroy();

    let filtered: any = []

    if (getAll) {
      filtered = await this.apiService.get("crmservice", "contact")
    }
    else {
      let para = ""
      if (this.firstnameSearch.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "firstname=" + this.firstnameSearch
      }
      if (this.lastnameSearch.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "lastname=" + this.lastnameSearch
      }
      if (this.telephoneSearch.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "telephoneno=" + this.telephoneSearch
      }
      if (this.idcardSearch.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "idcard=" + this.idcardSearch
      }
      if (this.accountNoSearch.trim() != "") {
        para += (para.length > 0 ? "&" : "") + "accountno=" + this.accountNoSearch
      }

      if (para.length > 0) {
        filtered = await this.apiService.get("crmservice", "contact", para)
      }
      else {
        filtered = await this.apiService.get("crmservice", "contact")
      }
    }

    if (filtered != null && filtered.length > 0) {
      this.contactList = filtered.filter((c: any) => {
        return c.statusreason == 1 || c.statusreason == "1"
      });
    }
    else {
      if (this.isCrisis) {
        await this.getDrosContact()
        await this.getDAContact()

        if (this.contactDros != null && this.contactDros.CRM06 != null) {
          //create crm contact ด้วยข้อมูลจาก DROS

          let firstname = ""
          let lastname = ""
          let phoneNo =  "" 
          try {
            let name: string = this.contactDros.CRM06.Name.split(" ")
            if (name.length > 0) {
              if (name.length == 1) {
                firstname = name[0]
              }
              else if (name.length == 2) {
                firstname = name[0]
                lastname = name[1]
              }
              else if(name.length > 2){ 
                for (let i = 0; i < name.length - 1; i++) {
                  firstname += " " + name[i]
                }
                firstname = firstname.trim()
                lastname = name[name.length - 1]
              }
            }
          }
          catch (e) {
            console.log(e)
          }

          
          if(this.telephoneNo != null && this.telephoneNo.trim().length > 0) 
          { 
              phoneNo =this.telephoneNo
          }
          else
          {
            phoneNo = this.contactDros.CRM06.PhoneNo
          }

          let req: any = {
            createdon: new Date().toISOString(),
            modifiedon: new Date().toISOString(),
            firstname: firstname,
            lastname: lastname,
            dpa_idcard: this.contactDros.CRM06.IDNo,
            dpa_authorizedperson_idcard: this.contactDros.CRM06.IDNo,
            dpa_authorizedperson_telephone: phoneNo,
            telephone1: phoneNo,
            emailaddress1: this.contactDros.CRM06.Email,
            statusreason: 1,
            //callcenterflag: true
          }

          await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
            if (this.util.isSuccessResponse(res)) {
              if (res.contactid != null && res.contactid != "") {
                //new tab customer4tab (2)
                //this.router.navigate(["/customer/" + res.contactid])
                this.search()
              }
              else {
                this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
              }
            }
            else {
              this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DROS ไม่สำเร็จ")
            }
          })
        }
        else if(this.contactDa != null && this.contactDa.FirstName != null)
        {
          
          let phone: string = this.contactDa.MobileNumber.split(",")
          let firstname = this.contactDa.FirstName
          let lastname = this.contactDa.LastName
          let phoneNo =  ""   
          if(this.telephoneNo != null && this.telephoneNo.trim().length > 0) 
          { 
            phoneNo =this.telephoneNo
          } 
          else
          {
            if (phone.length > 0 && phone[0] != "N/A")
            {
              phoneNo = phone[0]
            }
            else
            {
              phoneNo =this.telephoneNo
            }
            
          }

          let req: any = {
            createdon: new Date().toISOString(),
            modifiedon: new Date().toISOString(),
            firstname: firstname,
            lastname: lastname,
            dpa_idcard: this.contactDa.IdentityNumber,
            dpa_authorizedperson_idcard: this.contactDa.IdentityNumber,
            dpa_authorizedperson_telephone: phoneNo,
            telephone1: phoneNo,
            emailaddress1: this.contactDa.EmailAddress,
            statusreason: 1,
            //callcenterflag: true
          }

          await this.apiService.post("crmservice", "contact", req).then(async (res: any) => {
            if (this.util.isSuccessResponse(res)) {
              if (res.contactid != null && res.contactid != "") {
                //new tab customer4tab (2)
                this.router.navigate(["/customer/" + res.contactid])
              }
              else {
                this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
              }
            }
            else {
              this.util.ErrorDialog("สร้าง contact ด้วยข้อมูล DA ไม่สำเร็จ")
            }
          })
        }
        else {
          this.util.WarningDialog("ไม่พบข้อมูล")
        }
      }
    }

    this.util.ShowWaiting(false)
  }

  resetSearchCirteria() {
    this.firstnameSearch = ""
    this.lastnameSearch = ""
    this.telephoneSearch = ""
    this.idcardSearch = ""
    this.accountNoSearch = ""
  }

  ngAfterViewInit() {
    this.tbCon.changes.subscribe(t => {
      this.initTableCon()
    })
  }

  ngForRendred() {
    console.log('NgFor is Rendered');
    if (this.dtCon == null) {
      this.initTableCon()
    }
  }

  initTableCon() {
    let thisTs = this

    $('#tbContact td:not(.checkbox-col)').click(async function (event: any) {
      // if(thisTs.isCrisis){
      //   let para = "CRM02=true&CRM03=true&CRM04=true&CRM05=true&CRM06=true&CRM07=true"
      //   if (thisTs.idCard != null && thisTs.idCard.toString().trim().length > 0) {
      //     para += "&dpa_id=" + thisTs.idCard
      //   }
      //   if (thisTs.telephoneNo != null && thisTs.telephoneNo.toString().trim().length > 0) {
      //     para += "&telephoneno=" + thisTs.telephoneNo
      //   }
      //   thisTs.contactDros =  await thisTs.apiService.get("crmservice", "contactDros", para)//ค้น DROS

      //   if(thisTs.contactDros != null && thisTs.contactDros.length > 0){
      //     const url = thisTs.util.baseUrl() + `/customer/` + $(this).parent('tr').find("input[type='checkbox']")[0].value
      //     window.open(url, '_blank');
      //   }
      //   else{
      //     thisTs.util.ErrorDialog("ไม่พบข้อมูลใน DROS กรุณาติดต่อเจ้าหน้าที่")
      //   }
      // }
      // else{
      const url = thisTs.util.baseUrl() + `/customer/` + $(this).parent('tr').find("input[type='checkbox']")[0].value
      window.open(url, '_blank');
      // }
    });

    this.dtCon = $("#tbContact").DataTable({
      retrieve: true,
      'searching': false,
      "order": [],
      columnDefs: [{ orderable: false, targets: [0] }]
    });
  }

  mainChange(num: number) {
    this.chkMain = num
    this.chkName = num
    this.chkLastname = num
    this.chkDob = num
    this.chkIdNo = num
    this.chkEmail = num
    this.chkTel = num
  }

  async getDrosContact() {
    let para = "CRM06=true"
    if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
      para += "&dpa_id=" + this.idcardSearch
    }
    if (this.telephoneSearch != null && this.telephoneSearch.toString().trim().length > 0) {
      para += "&telephoneno=" + this.telephoneSearch
    }
    this.contactDros = await this.apiService.get("crmservice", "contactDros", para)//ค้น DROS
  }
  
  async getDAContact(){
    let para = ""
    if (this.idcardSearch != null && this.idcardSearch.toString().trim().length > 0) {
      para += "IdNo=" + this.idcardSearch
    } 
    this.contactDa =  await this.apiService.get("crmservice", "getDA", para)//ค้น DA
  }

}



// WEBPACK FOOTER //
// ./src/app/incoming-contact/incoming-contact.component.ts